import React, { Component } from "react";
import {
  withStyles,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Avatar,
} from "@material-ui/core";
import { styles } from "./traffic-light-info-box.css.js";
import CloseIcon from "@material-ui/icons/Close";
import { connect } from "react-redux";
import {
  trafficLightGreenInfo,
  trafficLightGreyInfo,
  trafficLightPurpleInfo,
  trafficLightLabel,
  trafficLightRedInfo,
  trafficLightAmberInfo,
} from "redux/Types.js";
import clsx from "clsx";

export const getTrafficLightColor = (id) => {
  if (id) {
    let index = trafficLightLabel.findIndex((e) => e.id === id);
    if (index !== -1) {
      return trafficLightLabel[index].color;
    } else return "";
  }
  return "";
};

export const getTrafficLightLabel = (id) => {
  if (id) {
    let index = trafficLightLabel.findIndex((e) => e.id === id);
    if (index !== -1) {
      return trafficLightLabel[index].label;
    } else return "N/A";
  }
  return "N/A";
};

class TrafficLightInfoBox extends Component {
  constructor(props) {
    super();
    this.state = {
      popOutOpen: false,
    };
  }

  handleOpen = (e) => {
    this.setState({ popOutOpen: true });
  };

  onClose = (e) => {
    this.setState({ popOutOpen: false });
  };

  render() {
    const { classes, data, PriorApproval } = this.props;

    const { popOutOpen } = this.state;

    return (
      <>
        {/* <Button
        aria-label="Open popup data"
        title="Open Popup "
        // className={classes.globalCreateAddButton}
        onClick={this.handleOpen}
         disabled={!data}
        >
        <OpenInNewIcon/> <span class="hideInside">Open in Popup</span>
     </Button>  */}
        {PriorApproval ? (
          <>
            <Avatar
              style={{ background: "purple " }}
              variant="rounded"
              onClick={this.handleOpen}
              title="Restricted"
              className={clsx(classes.singleView, classes.traffiCLights)}>
              {" "}
            </Avatar>
          </>
        ) : (
          <>
            <Avatar
              style={{
                background: `${data ? getTrafficLightColor(data) : "gray"}`,
              }}
              variant="rounded"
              onClick={this.handleOpen}
              className={clsx(classes.singleView, classes.traffiCLights)}>
              {" "}
            </Avatar>
          </>
        )}

        <Dialog
          open={popOutOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          // className={classes.dialogWrapper}
          className={classes.modalPopupWrap}>
          <DialogTitle id="alert-dialog-title">
            <div className={classes.modalContentHeader}>
              <div className={classes.modalContentTitle}>
                Traffic Light Indicator
                <Button
                  aria-label="Close Traffic Light Indicator"
                  className={clsx(classes.closeButton)}
                  title="Close"
                  onClick={() => {
                    this.onClose();
                  }}>
                  <CloseIcon />
                </Button>
              </div>
            </div>
          </DialogTitle>

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <div className={classes.textContainer}>
                <div>
                  <div className={classes.inlineAvatar}>
                    <Avatar
                      style={{ background: "green " }}
                      // variant="circle"
                      variant="rounded"
                      onClick={this.handleOpen}
                      className={clsx(classes.green, classes.traffiCLights)}>
                      {" "}
                    </Avatar>
                    Green Light
                  </div>
                  {trafficLightGreenInfo.map((info) => {
                    return (
                      <>
                        <div className={classes.infoText}>{info.text}</div>
                      </>
                    );
                  })}
                </div>
                <div>
                  <div className={classes.inlineAvatar}>
                    <Avatar
                      style={{ background: "red" }}
                      // variant="circle"
                      variant="rounded"
                      onClick={this.handleOpen}
                      className={clsx(classes.red, classes.traffiCLights)}>
                      {" "}
                    </Avatar>
                    Red Light
                  </div>
                  {trafficLightRedInfo.map((info) => {
                    return (
                      <>
                        <div className={classes.infoText}>{info.text}</div>
                      </>
                    );
                  })}
                </div>

                <div>
                  <div className={classes.inlineAvatar}>
                    <Avatar
                      style={{ background: "gray " }}
                      // variant="circle"
                      variant="rounded"
                      onClick={this.handleOpen}
                      className={clsx(classes.gray, classes.traffiCLights)}>
                      {" "}
                    </Avatar>
                    Grey Light
                  </div>
                  {trafficLightGreyInfo.map((info) => {
                    return (
                      <>
                        <div className={classes.infoText}>{info.text}</div>
                      </>
                    );
                  })}
                </div>

                <div>
                  <div className={classes.inlineAvatar}>
                    <Avatar
                      style={{ background: "purple " }}
                      // variant="circle"
                      variant="rounded"
                      onClick={this.handleOpen}
                      className={clsx(classes.purple, classes.traffiCLights)}>
                      {" "}
                    </Avatar>
                    Purple Light
                  </div>
                  {trafficLightPurpleInfo.map((info) => {
                    return (
                      <>
                        <div className={classes.infoText}>{info.text}</div>
                      </>
                    );
                  })}
                </div>
                <div>
                  <div className={classes.inlineAvatar}>
                    <Avatar
                      style={{ background: "yellow" }}
                      // variant="circle"
                      variant="rounded"
                      onClick={this.handleOpen}
                      className={clsx(classes.yellow, classes.traffiCLights)}>
                      {" "}
                    </Avatar>
                    Yellow Light
                  </div>
                  {trafficLightAmberInfo.map((info) => {
                    return (
                      <>
                        <div className={classes.infoText}>{info.text}</div>
                      </>
                    );
                  })}
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          {/* <DialogActions>
              <Button   onClick={this.onClose} color="primary" autoFocus>
                  Yes
          </Button>
                <Button  onClick={this.onClose} color="primary">
                  No
          </Button>
                
              </DialogActions> */}
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(
  mapStateToProps,
  {}
)(withStyles(styles)(TrafficLightInfoBox));
